import {
  AmazonConnectCredentialsModel,
  AmazonDataImportStatusModel,
  AmazonIntegration,
  PostAmazonConnectInput,
  PostClientAmazonConnectInput,
  PublicClient,
} from '../types';
import { client } from './axiosClient';

export const postTriggerAmazonDataImport = async () => {
  const res = await client.post('/client/amazon-import');
  return res.data;
};

export const postClientAmazonConnect = async ({
  company_id,
  seller_id,
  oauth_code,
}: PostClientAmazonConnectInput) => {
  const res = await client.post(
    '/client/amazon-connect',
    {
      seller_id,
      oauth_code,
    },
    {
      params: {
        company_id,
      },
    }
  );
  return res.data;
};

export const getAmazonConnectCredentials = async (): Promise<
  AmazonConnectCredentialsModel[]
> => {
  const res = await client.get('/client/amazon-connect');
  return res.data;
};

export const getAmazonDataImportStatus = async (
  controller?: AbortController
): Promise<AmazonDataImportStatusModel> => {
  const res = await client.get('/client/amazon-data-status', {
    signal: controller?.signal,
  });
  return res.data;
};

export const getIntegrations = async (company_id?: string) => {
  const res = await client.get<AmazonIntegration[]>('/client/seller-accounts', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const getClientForAmazonConnect = async (uuid: string) => {
  const res = await client.get<PublicClient>(`/client-data/${uuid}`);
  return res.data;
};

export const postAmazonConnect = async (data: PostAmazonConnectInput) => {
  const res = await client.post('/amazon-connect', data);
  return res.data;
};
